import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Loader2, LogIn } from "lucide-react";
import api, { LOGO_URL, BG_WELCOME } from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  if (localStorage.getItem("rivot_admin_token")) {
    return <Navigate to="/admin" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("rivot_admin_token", data.token);
      localStorage.setItem("rivot_admin_user", JSON.stringify(data.user));
      navigate("/admin", { replace: true });
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Invalid email or password");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="relative min-h-screen">
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <img src={BG_WELCOME} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/90 to-black/60" />
      </div>

      <header className="absolute top-0 left-0 right-0 px-6 md:px-12 pt-6 z-10">
        <img src={LOGO_URL} alt="RIVOT Motors" className="h-8 md:h-9 opacity-90" />
      </header>

      <main className="relative min-h-screen flex items-center px-6 md:px-16">
        <div className="w-full max-w-md">
          <div className="font-mono-rivot text-xs uppercase tracking-[0.35em] text-[color:var(--rivot-orange)] mb-4">
            Admin Console
          </div>
          <h1 className="font-display text-4xl sm:text-5xl font-light leading-none tracking-tight text-white">
            Sign in
          </h1>
          <p className="mt-4 text-zinc-400">
            Access RIVOT Motors dealership applications.
          </p>

          <form onSubmit={submit} className="mt-10 grid gap-6" data-testid="admin-login-form">
            <label className="grid gap-2">
              <span className="text-[11px] uppercase tracking-[0.25em] font-mono-rivot text-zinc-500">
                Email
              </span>
              <input
                type="email"
                required
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@rivotmotors.com"
                className="bg-transparent border-b border-zinc-700 focus:border-[color:var(--rivot-orange)] outline-none text-lg text-white py-2 transition-colors font-display"
                data-testid="admin-email-input"
              />
            </label>

            <label className="grid gap-2">
              <span className="text-[11px] uppercase tracking-[0.25em] font-mono-rivot text-zinc-500">
                Password
              </span>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="bg-transparent border-b border-zinc-700 focus:border-[color:var(--rivot-orange)] outline-none text-lg text-white py-2 transition-colors font-display"
                data-testid="admin-password-input"
              />
            </label>

            {error && (
              <div
                className="text-sm text-red-400 border border-red-900/50 bg-red-950/30 px-3 py-2"
                data-testid="admin-login-error"
              >
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={busy}
              className="rivot-btn mt-2 justify-center"
              data-testid="admin-login-submit"
            >
              {busy ? <Loader2 size={16} className="animate-spin" /> : <LogIn size={16} />}
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
